import useSWR from "swr";
import { fetcher } from "../../../services/fetcher";
import { Outlet, useNavigate, useParams, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { Box, Paper } from "@mantine/core";
import Tabs from "../../../common/components/Tabs/Tabs";
import MainLoader from "../../../common/components/Loader/Loader";
import OperatorHeader from "../components/OperatorHeader/OperatorHeader";

const endpoint = "operator/operator-profiles/";

const OperatorLayout = () => {
  const navigate = useNavigate();
  const { uuid } = useParams();
  const location = useLocation();
  const [currentTab, setCurrentTab] = useState(
    location.pathname.split("/").pop()
  );

  const {
    data: operator,
    error: operatorError,
    isLoading: isOperatorLoading,
    mutate: mutateOperator,
  } = useSWR(`${endpoint}${uuid}`, fetcher, {
    dedupingInterval: 60000,
    revalidateOnFocus: false,
  });

  const handleNavigation = (value) => {
    setCurrentTab(value);
    navigate(`/operator/operators/${uuid}/${value}`);
  };

  const headerVisibleTabs = new Set(["overview", "wallet"]);
  const shouldShowHeader = headerVisibleTabs.has(currentTab);

  const tabsConfig = [
    // {
    //   value: "overview",
    //   label: "Overview",
    //   icon: "/images/svg/profile.svg",
    //   roles: ["is_superuser", "Operator"],
    // },
    {
      value: "operator-profile",
      label: "Profile",
      icon: "/images/svg/profile.svg",
      roles: ["is_superuser", "Operator"],
    },
    {
      value: "operator-assign-covers",
      label: "Covers",
      icon: "/images/svg/covers.svg",
      roles: ["is_superuser"],
    },
    {
      value: "wallet",
      label: "Wallet",
      icon: "/images/svg/wallet.svg",
      roles: ["is_superuser", "Operator"],
    },
    {
      value: "commission",
      label: "Commission",
      icon: "/images/svg/comission.svg",
      roles: ["is_superuser", "Operator"],
    },
    {
      value: "policies-issued",
      label: "All Policy",
      icon: "/images/svg/comission.svg",
      roles: ["is_superuser", "Operator"],
    },
    {
      value: "operator-payments",
      label: "Payments",
      icon: "/images/svg/comission.svg",
      roles: ["is_superuser"],
    },
    {
      value: "qr-code",
      label: "QR Code",
      icon: "/images/svg/comission.svg",
      roles: ["is_superuser", "Operator"],
    },
    {
      value: "account-expiry",
      label: "Account Expiry",
      icon: "/images/svg/comission.svg",
      roles: ["is_superuser"],
    },
  ];

  useEffect(() => {
    setCurrentTab(location.pathname.split("/").pop());
  }, [location]);

  if (isOperatorLoading) {
    return <MainLoader />;
  }

  if (operatorError) {
    return <p>Something went wrong</p>;
  }

  return (
    <Box
      // px={{ base: 8, sm: 0 }}
      pt={0}
      pb={{ base: 20, sm: 24 }}
      
      style={{
        background: "#F3F8FE",
        // minHeight: "100%",
      }}
    >
      <Box >
        {shouldShowHeader && (
          <Paper
            radius={8}
            mb={24}
          >
            <OperatorHeader
              operator={operator}
              isExpanded
              showCollapseToggle={false}
            />
          </Paper>
        )}

        <Tabs
          currentTab={currentTab}
          onChange={handleNavigation}
          tabs={tabsConfig}
          variant="underline"
          separateContent
        >
          <Box pb={24} pt={0}>
            <Outlet context={{ operator, operatorError, mutateOperator }} />
          </Box>
        </Tabs>
      </Box>
    </Box>
  );
};

export default OperatorLayout;